import React from "react";
import FaqSection from "./FaqSection";
export const startingWithNomadroof = [
  {
    question: "What is Nomadroof?",
    answer:
      "Nomadroof is an online platform for students, travellers, professionals, or expats looking for mid-to long-term housing oversees or in different cities of their countries.Our goal is to excel and make easier all the steps of finding and booking a place to live, all this conveniently made online without wasting time.",
  },
  {
    question: "Why is Nomadroof the ideal place to publish my properties?",
    answer:
      "Nomadroof offers you an efficient platform where you can manage all your renting properties in one place. You will have access to many features such as messaging potential tenants or accepting a booking request. Moreover, your listings will be visible to thousands of international and financially committed tenants..",
  },
  {
    question: "Is Nomadroof for free?",
    answer:
      "Publishing your place is free as well as using our platform once your account and property have been verified. We also arrange a free photography session to show off your property. Depending on the city, we only charge a host service fee if you accept the booking request of tenant and he/she makes the payment.",
  },
  {
    question: "How do you advertise my property?",
    answer:
      "We promote our platform oversees through different advertising tools and social media methods. Your property will have higher visibility from international tenants that you have trouble reaching",
  },
  {
    question: "How can I create an account?",
    answer:
      "Click on the + Sign Up tab located in the top right side of the website. Sign up via Facebook, Gmail or create a username by providing your email address. If you choose the last option, you will be emailed a temporary password to access your new account.",
  },
  {
    question: "How do I update my contact information?",
    answer:
      "You first need to log in to your account. Once logged in, go to your “Dashboard” and click on “My Profile”. There, you will be able to update your contact information.",
  },
  {
    question: "What information in my profile is public?",
    answer:
      "Only your first name that you include in your profile is public. The other personal information in your profile will only be visible to Nomadroof. Once a booking and payment is confirmed, we will share your name, email address and phone number with the tenant.",
  },
  {
    question: "How do I change my password?",
    answer:
      "Go to your Dashboard and click on “My Profile” settings. Scroll down and you will be able to see the options to change your password.",
  },
  {
    question: "I forgot my password. How do I restore it?",
    answer:
      "Please contact us at customesupport@nomadroof.com so we can help you out.",
  },
  {
    question: "How do I access my Dashboard?",
    answer:
      "Once you have signed up or logged in, you will be redirected to your Dashboard. You can also access your Dashboard by clicking on your profile picture, located in the top right corner of the website.",
  },
  {
    question: "Why is very important to add my phone number and email?",
    answer:
      "It is very important to add your phone number and a correct email address in “My Profile” settings, because we will contact you to start with the verification process.",
  },
];

export const aboutListings = [
  {
    question: "How do I publish my property's listing?",
    answer:
      "Once you have signed up or signed in, go to your Dashboard and click on “Add New Property”. You will be redirected to a new page and will be ask to fill out the information of your property for Description, Price, Images, Details, Location, Amenities and Calendar.  On each stage, it is very important that you click on “SAVE” everytime you add or change something or the information will not be reflected on the listing.",
  },
  {
    question: "How do you verify my listing?",
    answer:
      "Once you have created an account and added a property, we will call you within 48 business hours. We will assure that the information provided is correct by asking you questions of your listing. We will also set up an appointment in accordance with your availability to check in person your property and if necessary provide you with a free photography session.",
  },
  {
    question: "What are the requirements for my listing to be approved?",
    answer:
      "You must provide your Legal Name and Last Name once you create an account. You must also add your telephone number in your profile as we will contact you to verify your account and schedule an appointment to see your property and make you a host interview. Your property must be livable and consistent with our quality standards for a confort stay of tenants. We reserve the rights to approve or decline a property.",
  },
  {
    question: "How can I get a free photography session?",
    answer:
      "If your property verification is approved, we will contact you to schedule a free photography session. If you already have high quality photos, this step is not necessary and you will be able to have your property visible to thousands of international tenants.",
  },
  {
    question: "Where do I manage my properties' listings?",
    answer:
      "Go to your Dashboard and click on “My properties”. You will be able to see, edit or delete all the listings that you have added and have been approved for publish.",
  },
  {
    question: "What should I add in the description of my property?",
    answer:
      "Once your listing is approved, we will ask you to send us detailed information about what you are offering. Please be clear on the features and amenities. You should also add the rules for renting your property and any other necessary information that tenant must know before booking. We will add this information for you in the listing and send it to you to approve it. Once this step is over, your listing will be available for tenants.",
  },
  {
    question: "What price should I charge?",
    answer:
      "You are the only one that decide the renting price for your property. You might want to check the renting price of other similar listings in your area for references.",
  },
  {
    question: "What is the currency I should use for my listing?",
    answer: "You should display the renting period in US DOLLARS.",
  },
  {
    question: "Can I have special rules for tenants?",
    answer:
      "Yes, you can have special rules for tenant, but these should be stated in the property description.",
  },
  {
    question:
      "I have rooms with different prices all in one property, can all they be in one listing?",
    answer: "No, you will have to create a separate listing for each room.",
  },
  {
    question: "How can I set up the availability of my property?",
    answer:
      "If you are adding a property go to Calendar. If you already have a listing Go to “My Properties” located in your Dashboard and then to Calendar. In Calendar, you will be able to select the starting date and the ending date of availability. You can also check the box “Unlimited Availability” if your property will have unlimited availability from the date you select as starting date onwards",
  },
  {
    question: "How long is the rental period?",
    answer:
      "The minimum rental period is 1 month. You can negotiate with tenant if the staying period is less than one month. However, tenant will still need to pay the amount equivalent to first month’s rent through Nomadroof’s platform.",
  },
  {
    question: "What is an Internal Booking and External Booking?",
    answer:
      "An internal booking is the booking that you generate outside of the platform via other methods. External booking is the booking that gets generated automatically once you accept a booking request and tenant pays the first month’s rent through Nomadroof.",
  },
  {
    question: "How do I apply internal booking in the calendar?",
    answer:
      "Go to the calendar settings and on the calendar table bellow, click on the dates that you have internally booked your property. A Tab requesting the dates you want to mark as internal booking will show up. Select the dates, write your notes and click on Book Period. The dates for internal booking will appear in the calendar with orange color. In the published listing visible to tenant, the orange external bookings are mark as light grey “Not Available”.",
  },
  {
    question: "Can a tenant visit my property before booking and paying?",
    answer:
      "Physical visits to the property before booking and paying is not available in Nomadroof as we are a platform that facilitates the renting process via online. It would not be necessary neither, as most of the potential tenants book a place when they are still in their country.",
  },
  {
    question: "Why do I need to update the availability of my properties?",
    answer:
      "You listing is visible to thousands of potential tenants and they want to know if the availability of your property matches his or her staying period. Therefore, if you take care of updating the availability, you will be more likely to receive more booking requests.",
  },
];

export const faqData = [
  {
    title: "MESSAGES AND BOOKING REQUESTS",
    items: [
      {
        question: "Can I message potential tenants?",
        answer:
          "You cannot message potential tenants unless there is a booking confirmed. Once booking payment is made, both parties will be able to see each other’s contact details and the message center within the platform will open so you can chat.",
      },
      {
        question: "Where do I find the messages of tenants?",
        answer:
          "You will find your conversations in your Dashboard. Click on MY INBOX and respond to messages after booking is confirmed. You will also receive notifications of new messages by email.",
      },
      {
        question: "Is it safe to accept a booking request?",
        answer:
          "Yes it is safe to accepta booking request. Most of potential tenants are international students or young professionals and they are financially committed as once you approved a booking request, they will have to make a payment of the first month’s rent. We hold this deposit and later transfer it to you so you can feel confident about accepting a tenant through our platform.",
      },
      {
        question: "Where can I manage my bookings requests?",
        answer:
          "You can manage your bookings requests in “My Bookings” settings located in your Dashboard. You will be able to see the name of the person that requested a booking and the dates of his/her stay.",
      },
      {
        question: "Can I see the profile of the potential tenant?",
        answer:
          "Yes, when a potential tenant sends you a booking request, you will receive a notification and an invoice that is located  in “My Bookings” section of your Dashboard. Within the invoice,  click on the Name of the potential tenant and you will be able to see a picture, country of origin, description and other details about him/her.",
      },
      {
        question: "How do I accept a booking request?",
        answer:
          "Go to “My Bookings” in your Dashboard and you will see the property that was requested for booking. Click on “ISSUE INVOICE” to see the details of the booking and then click SEND INVOICE. Tenant will now know that you have accepted the booking request, and he/she will be able to pay for the booking.",
      },
      {
        question:
          "How much time do I have to accept or reject a booking request?",
        answer:
          "You will have 48 hours to accept or reject a booking request. After that period, the booking request is automatically cancel.",
      },
      {
        question: "When is the booking confirmed?",
        answer:
          "When you accept the booking request, tenant needs to make the payment though Nomadroof’s platform of the invoice that is equivalent to first month’s rent plus booking service. Once the payment is made, you can rest assure that the booking is confirmed.",
      },
      {
        question: "What is the tenant paying me through Nomadroof?",
        answer:
          "Tenant will be paying the first month’s rent. We will hold this amount and will transfer it to you (total amount – host service fee) 24 hours after move-in date, if everything is accordingly.",
      },
    ],
  },
  {
    title: "AFTER BOOKING AND MOVE IN DATE",
    items: [
      {
        question: "How do I set up the rental agreement?",
        answer:
          "Once the booking request is paid, you should arrange the signing of the rental agreement with Tenant separately from the platform as we do not handle or provide any type of contracts.",
      },
      {
        question:
          "How can tenant pay me for the security deposit and other fees that I requested in my listing?",
        answer:
          "We only handle the first month’s rent. Once the booking payment is confirmed, we will share to both parties their contact information so you can discuss on how you will handle the security deposit and any other fees.",
      },
      {
        question: "What happens if tenant wants to change the staying dates?",
        answer:
          "You are the solely responsible to accept or decline a changing in tenant’s staying dates. If you decide not to accept the new dates, you might be eligible to keep the first month’s rent as compensation. Please send us an email to customersupport@nomadroof.com to update the information of your listing and help you with this matter.",
      },
      {
        question: "What is the 24 hours Tenant’s check policy?",
        answer:
          "The 24 hours policy means that tenant has a 24 hours period to check the property for major defects (e.g. water leaks, infestation, mold) to send a complaint for a refund. If a property is rundown and unlivable, or it differs completely from the description of the listing as seen in our platform, the tenant has the right to send a complaint to be fully refunded. For more information, please refer to our Refund PolicyIf you have an issue or complaint please let us know! We are here to help you.",
      },
      {
        question: "How do I receive the remaining months of rent?",
        answer:
          "The remaining months of rent are usually paid in person to you or however you had discussed it with Tenant. At the moment, we only handle the first month’s rent..",
      },
      {
        question:
          "Can a tenant cancels the booking request once he/she has already paid?",
        answer:
          "Yes, however tenant might incurred a penalty fee depending on the time the booking was cancel. Therefore you might be eligible to have the first month’s rent as a compensation. Please refer to our Terms and Conditions for detailed information.",
      },
      {
        question: "What if tenant does not show up on the move in date?",
        answer:
          "You can contact us at customersupport@nomadroof.com if this issue arises. We will contact tenant to see if he or she is experiencing a delay issue, but we will still proceed with transferring you the first month’s rent after 24 hours of the move in date..",
      },
      {
        question:
          "Does tenant has to pay me the remaining renting months in US DOLLARS?",
        answer:
          "No, you should discuss and agree with Tenant on the currency you will be using for the remaining renting months.",
      },
      {
        question: "Do you provide an Invoice?",
        answer:
          "Yes, we provide an invoice for the host service fee amount. We recommend you to inform yourself about your local taxes for renting a property as we are not tax advisors.",
      },
    ],
  },
];
export const Payment = [
  {
    title: "PAYMENT TRANSFER AND CANCELLATIONS",
    items: [
      {
        question: "When and how do I receive my payment of first month’s rent?",
        answer: (
          <>
            <p>
              We will start with the payment transfer of the first month’s rent,
              24 hours after that tenant has moved in. The transfer can take up
              to 3-5 business days. We will transfer you the first month’s rent
              of tenant minus the host service fee directly to your bank
              account, via PayPal, Western Union or MoneyGram. Please see below
              for the options of your country.
            </p>
            <br />
            <p className="font-semibold">USA</p>
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>Bank Account Transfer and PayPal.</li>
            </ul>
            <br />
            <p className="font-semibold">LIMA, PERU</p>
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>PayPal</li>
              <li>MoneyGram</li>
            </ul>
            <br />
            <p className="font-semibold">COLOMBIA</p>
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>Paypal</li>
              <li>Western Union</li>
            </ul>
            <br />
            <p className="text-xs italic">
              *We will contact you one week before your new tenant will move in
              to your property so you can provide us with your option for
              transferring your first month’s rent.
            </p>
          </>
        ),
      },
      {
        question: "What is the host service fee?",
        answer: (
          <>
            <p>
              The host service fee is a percentage amount of the total renting
              period and it is discounted of the tenant’s payment that we would
              transfer you 24 hours after tenant’s check-in. The host service
              fee covers the cost of handling the money transfer, currency
              exchange, and operations. This fee is only charged once you have
              confirmed a booking request and tenant pays for the first month’s
              rent.{" "}
            </p>
            <br />
            <p className="font-semibold">Countries’ Fees:</p>
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>Peru: 7%-8%</li>
              <li>Colombia: 8%</li>
              <li>USA: 9%</li>
            </ul>
          </>
        ),
      },
      {
        question: "What is the cancellation policies?",
        answer:
          "Please refer to our Terms and Conditions for detailed information..",
      },
      {
        question: "Can I cancel the booking?",
        answer:
          "You can cancel a booking that is already been paid out, however, this action might affect your listing and future listings. Please refer to our Terms and Conditions for detailed information.",
      },
      {
        question:
          "What is the currency you use to transfer me the first month's rents?",
        answer: "We will transfer you the first month’s rent in US DOLLARS.",
      },
    ],
  },
  {
    title: "REVIEWS AND HELP",
    items: [
      {
        question: "Do You need more help?",
        answer: (
          <>
            <p>
              If you have more questions or need help, please contact us at:
            </p>
            <br />
            <p className="font-semibold">Countries’ Fees:</p>
            <ul className="list-disc ml-6 text-sm text-gray-600">
              <li>Email: customersupport@nomadroof.com</li>
            </ul>
          </>
        ),
      },
    ],
  },
];

const FaqLandlords = () => {
  return (
    <div>
      <hr className="border-orange-500 my-8" />
      <div className="mb-8">
        <h1 className="text-3xl mb-2">INFORMATION FOR LANDLORDS</h1>
        <p className="text-sm mb-8">
          Here you will find a collection of information. Contact us if you have
          more questions.
        </p>
        <hr className="border-orange-500 mb-8" />

        <div className="flex flex-col md:flex-row md:space-x-10">
          <FaqSection
            title="Starting with Nomadroof"
            items={startingWithNomadroof}
          />
          <FaqSection
            title="About My Property's Listings"
            items={aboutListings}
          />
        </div>
        <hr className="border-orange-500 mb-8" />
        <div className="flex flex-col md:flex-row md:space-x-10">
          {faqData?.map((section, index) => (
            <FaqSection
              key={index}
              title={section.title}
              items={section.items}
            />
          ))}
        </div>
        <hr className="border-orange-500 mb-8" />
        <div className="flex flex-col md:flex-row md:space-x-10">
          {Payment?.map((section, index) => (
            <FaqSection
              key={index}
              title={section.title}
              items={section.items}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqLandlords;
